import $ from 'jquery';
import { View } from 'backbone';

import notificationService from 'NotificationService.js';
import contentTemplate from '../../../templates/common-views/upload-file-modal.ejs';
import restService from 'RestService.js';
import constants   from 'Constants';
import util        from 'util/Util.js';
import Spinner from 'spin/spin';
import eventBus from 'EventBus';
import listService from 'ListService.js';

class UploadFileModalView extends View {
    initialize( opts ) {
        this.spinner = new Spinner();
        this.options = opts || {};
        this.listenTo(this.model, 'change', this.render);
        this.template = contentTemplate;
        this.$el = $(constants.CONTENT_ID);
        this.currentStep = 1;
        this.minStep = 1;
        this.maxStep = 3;
        
        if (this.options && this.options.model) {
            this.width = this.options.model.get('width');
            this.height = this.options.model.get('height');
        }
        
        
        
        this.allowedMimeTypes = {
            'pa': true,
            'pf': true
        };

        console.log('DemoDialogView initialized');
        return this;
    }

    set selectedImport(value){
        this._selectedImport = value;
    }

    uploadFileGotoPreviousStep() {
        if (this.currentStep > this.minStep) {

            this.currentStep--;
            var nextStepEl = '.upload-file-step-' + this.currentStep.toString();

            $('.step-template').addClass('hide');
            $(nextStepEl).removeClass('hide');
        }

        if (this.currentStep < this.maxStep) {
            $('.btn-uploadFileNext').prop("disabled",false).removeClass('ui-button-disabled  ui-state-disabled');
        }

        if (this.currentStep === this.minStep) {
            $('.btn-uploadFileBack').prop("disabled",true).addClass('ui-button-disabled  ui-state-disabled');
        }
    }
    uploadFileGotoNextStep() {
        if (this.currentStep === 1) {
            this.file = $('#file-upload')[0].files[0];
            if(!this.file){
                $('.error_message').text('No file selected, please select a file');
                $('.error_message').removeClass('hide');
                return;
            }
            if(! this.fileIsAllowed(this.file)){
                $('.error_message').text('Wrong file type, please correct');
                $('.error_message').removeClass('hide');
                return;
            }
            $('.error_message').text('');
            $('.error_message').addClass('hide');
        }

        if (this.currentStep < this.maxStep) {

            this.currentStep++;
            var nextStepEl = '.upload-file-step-' + this.currentStep.toString();

            $('.step-template').addClass('hide');
            $(nextStepEl).removeClass('hide');
        }

        if (this.currentStep > this.minStep) {
            $('.btn-uploadFileBack').prop("disabled",false).removeClass('ui-button-disabled  ui-state-disabled');
        }

        if (this.currentStep === this.maxStep) {
            $('.btn-uploadFileNext').prop("disabled",true).addClass('ui-button-disabled  ui-state-disabled');
        }

        if (this.currentStep === 2) {
            var filename = $('#file-upload').val();

            // Extract filename from path
            filename = filename.replace(/^.*[\\\/]/, '')
                               .replace(/\.[^/.]+$/, "")
                               .replace('(Connection)','')
                               .replace('(Report)','')
                               .replace('(Form)','')
                               .replace('(App)','').trim();

            $('#filename-upload').val(filename);
        }
        if (this.currentStep === 3) {
            var name = $('#filename-upload').val();
            $('.upload-file-step-3').removeClass('hide');
            this.importFileToServer(name);
        }
    }

    fileIsAllowed(file){
        console.log('File Type',file);
        const filePieces = file.name.split('.');
        return this.allowedMimeTypes[filePieces[filePieces.length-1]];
    }

    importFileToServer(name) {
        this.enablePostImportControls(false);
        var fileContents =$('#file-upload')[0].files[0];
        restService.importFile(name,fileContents,constants.DEFAULT_GROUP_ID,this._selectedImport)
            .then(this.processResult.bind(this))
            .catch(this.processError.bind(this));
        this.makeModalDone();

    }

    // Callback for a succesfull result.
    processResult(response) {
        this.enablePostImportControls(true);
        console.log('processResult - ' + response);
        if (response.RESULT.ERROR.CODE !== '0') {
            notificationService.error('Failed To Import File');          
        } else {
            // Getting the imported form and placing it into the modal status area.
            let importedObject = response.RESULT.RESPONSE.Import.Item;
            let type = importedObject["@type"].charAt(0).toUpperCase() + importedObject["@type"].slice(1);
            type = type === "Form" ? "App" : type;
            
            let dependecies = 'None';
            if(importedObject.Dependencies && importedObject.Dependencies.Dependency){
                const deps = Array.isArray(importedObject.Dependencies.Dependency) ? importedObject.Dependencies.Dependency : [importedObject.Dependencies.Dependency];
                dependecies = '</br>';
                for (let i = 0; i < deps.length; i++) {

                    let depType = deps[i]["@type"] === "form" ? "app" : deps[i]["@type"];

                    dependecies += ' - ';
                    dependecies += depType.charAt(0).toUpperCase() + depType.slice(1);
                    dependecies += ' "' + deps[i]["@caption"] + '" : ';
                    dependecies += util.isTrue(deps[i]["@found"])?'OK </br>':'Missing </br>';
                }
               
            }

            let urlExist = "";  
            let successfully = "successfully ";      

            if(listService.activeDashboardTab.toLowerCase() === 'connections'){
                //If it is bu license and the wssource does not exist
                const isBULicense = util.isTrue(listService.accountSettings.IsBULicense);                 
                if(isBULicense && !util.isTrue(importedObject['@WSSourceExists'])){
                    urlExist = "<div>The connection has been imported, but the URL is not listed in the REST/SOAP Service URL catalog. To ensure the connection works, please add the source to the catalog.</div><br/>";          
                    successfully = "";
                }
            }
    
            $("#import-file-status").html(`${urlExist}<div>The following items have been ${successfully}imported:</div>
                                            <b>"${type + ": " + importedObject['@caption']}"</b>
                                            <div>Dependencies:${dependecies}</div>`)

            this.refreshSections();
              eventBus.trigger(type === "App" ? 'reloadTable' : 'reloadTableReport');
            notificationService.success('File was succesfully imported');
        }

    }

    refreshSections() {
        if (listService.activeDashboardTab.toLowerCase() === 'forms') {
            if(listService.dashboardLayout.mainPanelView.className && (listService.dashboardLayout.mainPanelView.className() === 'EditFormsDashboardView' ||
                listService.dashboardLayout.mainPanelView.className() === 'FormMainView')){
                eventBus.trigger(constants.EV_REFRESH_EDIT_FORMS_DASHBOARD, true);
            }
        } else if (listService.activeDashboardTab.toLowerCase() === 'reports') {

            if (listService.dashboardLayout.mainPanelView.className && (listService.dashboardLayout.mainPanelView.className() === 'ViewReportsDashboardView' ||
            listService.dashboardLayout.mainPanelView.className() === 'EditReportsDashboardView')) {
                eventBus.trigger(constants.EV_REFRESH_REPORT_MAIN_VIEW_DETAILS, true);
            }
           

        } else if (listService.activeDashboardTab.toLowerCase() === 'connections') {

            if (listService.dashboardLayout.leftPanelView.nodeType) {
                let nodeType = listService.dashboardLayout.leftPanelView.nodeType.toUpperCase();
                if (!isNaN(nodeType)) {
                    nodeType = this.getConnectionNodeTypeText(nodeType);
                }

                const groupType = constants[nodeType + '_GROUP_TYPE'],
                      connectionGroupContainer = constants['CONNECTION_' + nodeType + '_CONTAINER'],
                      connectionGroupSection = constants['CONNECTION_' + nodeType + '_SECTION'];

                setTimeout(function() {
                    eventBus.trigger(constants.EV_REFRESH_CONNECTION_NODES,
                        groupType,
                        connectionGroupContainer,
                        connectionGroupSection);
                }, 500);
            }
            
        }
    }

    getConnectionNodeTypeText(nodeType) {
        let nodeTypeNumber = nodeType;
        if (!isNaN(nodeType)) {
            nodeTypeNumber = Number(nodeType);
        }
        let nodeTypeText = '';

        switch (nodeTypeNumber) {
            case 1:
                nodeTypeText = constants.CONNECTION_DATABASES_SECTION.toUpperCase();
                break;
            case 2:
                nodeTypeText = constants.CONNECTION_DIRECTORY_SECTION.toUpperCase();
                break;

            case 3:
                nodeTypeText = constants.CONNECTION_WEB_SECTION.toUpperCase()
                break;

            case 4:
                nodeTypeText = constants.CONNECTION_FORMS_SECTION.toUpperCase();
                break;

            case 5:
                nodeTypeText = constants.CONNECTION_GOOGLE_SECTION.toUpperCase();
                break;

            case 6:
                nodeTypeText = constants.CONNECTION_TEXT_SECTION.toUpperCase();
                break;

            case 11:
                nodeTypeText = constants.CONNECTION_REST_SECTION.toUpperCase();
                break;
        }
        return nodeTypeText;
    }

    // Callback for errors.
    processError(errorThrown){
        this.enablePostImportControls(true);
        notificationService.error('File was not imported succesfully');
        switch(errorThrown.RESULT.ERROR.CODE){
            case "22":$("#import-file-status").html(`<div>Import Failed.</div><div>The maximum number of apps allowed for this account has been reached.</div>`);break;
            case "23":$("#import-file-status").html(`<div>Import Failed.</div><div>The maximum number of reports allowed for this account has been reached.</div>`);break;
            case "49":$("#import-file-status").html(`<div>Import Failed.</div><div>Import Failed.The import file does not contain valid data.</div>`); break;
            case "67":$("#import-file-status").html(`<div>Import Failed.</div><div>The import file does not contain the required item type.</div>`); break;
            case "193":$("#import-file-status").html(`<div>Import Failed.</div><div>REST and SOAP Webservices connections are not enabled on this account.</div>`); break;
            case "194":$("#import-file-status").html(`<div>Import Failed.</div><div>The maximum number of REST and SOAP Webservices connections allowed for this account has been reached.</div>`); break;
            case "195":$("#import-file-status").html(`<div>Import Failed.</div><div>Connection Agent connections are not enabled on this account.</div>`); break;
            case "196":$("#import-file-status").html(`<div>Import Failed.</div><div>The maximum number of Connection Agent connections allowed for this account has been reached.</div>`); break;
            case "197":$("#import-file-status").html(`<div>Import Failed.</div><div>Google Sheets connections are not enabled on this account.</div>`); break;
            case "198":$("#import-file-status").html(`<div>Import Failed.</div><div>The maximum number of Google Sheets connections allowed for this account has been reached.</div>`); break;
            case "999":$("#import-file-status").html(`<div>Import Failed.</div><div>The selected file type is not supported.  Apps and reports created in 4.x or earlier versions cannot be imported currently.</div>`); break;
            default:$("#import-file-status").html(`<div>Import Failed.</div><div>The import file failed.</div>`); break;
        }
    }

    showSpinner(show){
        if (show){
            this.spinner.spin($(constants.CONTENT_ID).get(0));
        } else {
            this.spinner.stop();
        }
    }

    enablePostImportControls(enableControls) {
        if (enableControls) {
            $('.btn-uploadFileCancel').prop('disabled', !enableControls).removeClass('ui-button-disabled  ui-state-disabled');
            this.showSpinner(false);
        } else {
            $('.btn-uploadFileCancel').prop('disabled', !enableControls).addClass('ui-button-disabled  ui-state-disabled');
            this.showSpinner(true);
        }
    }

    // Disabling back and next buttons. And also changing the cancel button value as done.
    makeModalDone(){
        $('.btn-uploadFileBack').prop("disabled",true).addClass('ui-button-disabled  ui-state-disabled');
        $('.btn-uploadFileNext').prop("disabled",true).addClass('ui-button-disabled  ui-state-disabled');
        $('.btn-uploadFileCancel').text('Done');
        $('.btn-uploadFileCancel').prop("disabled", true).addClass('ui-button-disabled  ui-state-disabled');
    }

    render() {
        this.$el.append(this.template(this.model.toJSON()));

        var self = this;
        // Show modal popup window
        const dialog = $( '#dialog-form' ).dialog({
            dialogClass: "no-close",
            autoOpen: true,
            height: this.height || 300,
            width: this.width || 600,
            modal: true,
            resizable: false,
            buttons: [
                {
                    text: 'Back',
                    'class':'btn-uploadFileBack',
                    click: function() {
                        self.uploadFileGotoPreviousStep();
                    },
                    disabled:true
                },
                {
                    text: 'Next',
                    'class':'btn-uploadFileNext',
                    click: function() {
                        self.uploadFileGotoNextStep();
                    },
                    disabled:true
                },
                {
                    text: 'Cancel',
                    'class':'btn-uploadFileCancel',
                    click: function() {
                        dialog.dialog( "close" );
                    }
                }
            ],
            close: function() {
                dialog.dialog("destroy");
                $( '#dialog-form').remove();
            }
        });

        // Placing the file name selected on the input text.
        $('#file-upload').change(function(e) {
            var f =$('#uploaded-file');
            f.val(e.target.value.split( '\\' ).pop());
            $('.btn-uploadFileNext').prop('disabled',false).removeClass('ui-button-disabled  ui-state-disabled');
        });

        $('div[role="dialog"]').draggable(constants.DEFAULT_DRAGGABLE_OPTIONS);

        return this;
    }
}
export default UploadFileModalView;